var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#898e9a;stroke:#898e9a;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.113,20H13.4a1.65,1.65,0,0,0-1.648,1.648v10.83A1.65,1.65,0,0,0,13.4,34.126H28.113a1.65,1.65,0,0,0,1.648-1.648V21.648A1.65,1.65,0,0,0,28.113,20Zm0,.942a.7.7,0,0,1,.449.166l-7.806,6.066-7.806-6.066a.7.7,0,0,1,.449-.166Zm0,12.242H13.4a.708.708,0,0,1-.706-.706V22.1l8.064,6.265L28.819,22.1V32.478A.708.708,0,0,1,28.113,33.184Z",
    transform: "translate(-11.75 -20)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoContact);
export default __webpack_public_path__ + "static/media/picto-contact.3fb9c1571b5eef367c3b47792a89c052.svg";
export { ForwardRef as ReactComponent };